import React, { createContext, useContext, useEffect, useState } from 'react';

const initialState = {
  user: {},
  accessToken: undefined,
};
 
const UserContext = createContext(initialState);
 
export function UserProvider({ children }) {
  const [accessToken, setAccessToken] = useState(localStorage.getItem('access_token'));
  const [user, setUser] = useState(JSON.parse(localStorage.getItem('data')));

 
  useEffect(() => {
    if (accessToken) {
      localStorage.setItem('access_token', accessToken);
    } else {
      localStorage.removeItem('access_token');
      setUser({});
    }
  }, [accessToken]);

  useEffect(() => {
    if (user && user.name) {
      localStorage.setItem('data', JSON.stringify(user));
      //localStorage.setItem('user', user);
    } else {
      // Log Out
      localStorage.removeItem('data');
      localStorage.removeItem('user');
    }
  }, [user]);
 
  return (
    <UserContext.Provider value={{ user, accessToken, setAccessToken, setUser }}>
      {children}
    </UserContext.Provider>
  );
}
 
export const useUser = () => useContext(UserContext);
